// extracted by mini-css-extract-plugin
export var icon = "_ap-3";
export var subtitle = "_ap-2";
export var title = "_ap-1";
export var value = "_ap-0";